export class TokenModel {
    keyword   = '';
    component = 0;
}